import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
import { focusVisible } from '../../shared/global.styles.js';
var SelectButtonContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  display: inline-flex;\n  gap: ", "px;\n  padding: ", "px;\n  position: relative;\n  z-index: ", ";\n\n  &:after {\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: ", "px;\n    content: '';\n    display: block;\n    top: 0;\n    bottom: 0;\n    left: ", ";\n    margin: ", ";\n    position: absolute;\n    transition: left 300ms ease;\n    width: ", ";\n    z-index: ", ";\n  }\n"], ["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  display: inline-flex;\n  gap: ", "px;\n  padding: ", "px;\n  position: relative;\n  z-index: ", ";\n\n  &:after {\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: ", "px;\n    content: '';\n    display: block;\n    top: 0;\n    bottom: 0;\n    left: ", ";\n    margin: ", ";\n    position: absolute;\n    transition: left 300ms ease;\n    width: ", ";\n    z-index: ", ";\n  }\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.white;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.medium;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs2;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxxs;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.attributes) === null || _b === void 0 ? void 0 : _b.zIndex.low;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.blueLight;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.border;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs;
}, function (_a) {
  var _b;

  var selected = _a.selected,
      theme = _a.theme,
      length = _a.length,
      width = _a.width;
  return !selected ? '0' : "calc(".concat((selected + 1) * (100 / (length !== null && length !== void 0 ? length : 0)), "% - ").concat(width, "px + ").concat((_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxxs, "px)");
}, function (_a) {
  var _b, _c, _d;

  var selected = _a.selected,
      theme = _a.theme;
  return !selected ? "".concat((_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs, "px") : "".concat((_c = theme.spacings) === null || _c === void 0 ? void 0 : _c.xxs, "px -").concat((_d = theme.spacings) === null || _d === void 0 ? void 0 : _d.xxs, "px");
}, function (_a) {
  var _b;

  var theme = _a.theme,
      width = _a.width;
  return "calc(".concat(width, "px - ").concat((_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxxs, "px)");
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.attributes) === null || _b === void 0 ? void 0 : _b.zIndex.low;
});
var SelectButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: transparent;\n  border: none;\n  border-radius: ", "px;\n  cursor: pointer;\n  font-weight: ", ";\n  font-size: ", "px;\n  height: ", "px;\n  width: ", "px;\n  outline: none;\n  text-align: center;\n  z-index: ", ";\n\n  ", "\n\n  ", "\n"], ["\n  background: transparent;\n  border: none;\n  border-radius: ", "px;\n  cursor: pointer;\n  font-weight: ", ";\n  font-size: ", "px;\n  height: ", "px;\n  width: ", "px;\n  outline: none;\n  text-align: center;\n  z-index: ", ";\n\n  ", "\n\n  ", "\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.weight.medium;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.size.s2;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.lg;
}, function (_a) {
  var width = _a.width;
  return width;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.attributes) === null || _b === void 0 ? void 0 : _b.zIndex.middle;
}, function (_a) {
  var _b;

  var selected = _a.selected,
      theme = _a.theme;
  return !selected && "&:active {\n      background-color: ".concat((_b = theme.palette) === null || _b === void 0 ? void 0 : _b.lighter, ";\n    }");
}, focusVisible);
var templateObject_1, templateObject_2;
export { SelectButton, SelectButtonContainer };